export const EMLogo = () => {
  return (
    <svg
      className="block h-5 w-5"
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 162 292"
    >
      <polygon
        className="cls-1"
        fill="#000"
        points="162 32 162 0 0 0 0 292 33 292 33 162 65 162 65 292 97 292 97 162 130 162 130 292 162 292 162 129 33 129 33 97 162 97 162 64 33 64 33 32 162 32 162 32"
      />
    </svg>
  );
};
